import React from 'react' // eslint-disable-line

import styled from 'styled-components'
import { Column, Row } from 'styles/general'
import { Button } from 'styles/algolia/button'
import { Header, ActionsLinks } from 'styles/algolia/collection/header'
export const Thumbline = styled.div`
  display: flex;
  margin-top: 10px;
  justify-content: space-between;
  [data-type='thumb-image'] {
    display: inline-flex;
    width: 32%;
    height: auto;
  }
`
export const TitleBanner = styled(Column)`
  display: flex;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 24px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.25);
  span {
    display: block;
    padding: 0 10px;
  }
  @media (max-width: 1200px) {
    height: 98%;
  }
`
export const ArtworkMainText = styled.h2`
  /*  18px => ${(props) => props.theme.fontSizes[4]}px; */
  font-size: 17px;
  color: ${(props) => props.theme.colors.default};
  margin: 5px 0 0;
  font-weight: normal;
`
export const ArtworkSubText = styled.h4`
  font-size: ${(props) => props.theme.fontSizes[2]}px;
  color: ${(props) => props.theme.colors.gray};
  margin: 2px 0 0;
  font-weight: normal;
  &[data-type='date'] {
    font-size: ${(props) => props.theme.fontSizes[1]}px;
    font-weight: 100;
    margin-top: -3px;
    text-align: right;
    width: 100%;
  }
  &[data-type='dimensions'] {
    display: none;
    @media (min-width: ${(props) => props.theme.breakpoints[1]}) {
      display: block;
    }
  }
  @media (max-width: 720px) {
    height: 60px;
  }
  @media (max-width: 480px) {
    height: 90px;
  }
`
export const ArtworkInfo = styled(Column)`
  font-size: ${(props) => props.theme.fontSizes[3]}px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: ${(props) => props.theme.fontSizes[4]}px;
  a {
    text-decoration: none;
    color: ${(props) => props.theme.colors.default};
    transition: color 0.5s ease 0s;
    &:hover {
      color: ${(props) => props.theme.colors.black};
    }
  }
  h2, h3, h4 {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin: 0;
  }
  ${Row} {
    ${Column} {
      width: 70%;
      + ${Column} {
        width: 40%;
      }
    }
  }
  [data-type='prices'] {
    p {
      margin: 1px;
    }
  }
  @media (min-width: ${(props) => props.theme.breakpoints[1]}) {
    ${Row} ${Column} {
      margin-bottom: ${(props) => props.theme.space[2]}px;
    }
    [data-display='short'] {
      width: 86%;
    }
  }
  @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
    [data-type='mainInfo'] {
      h2, h3,
      a {
        color: ${(props) => props.theme.colors.default};
        font-size: ${(props) => props.theme.fontSizes[3]}px;
      }
    }
    ${ArtworkSubText} {
      display: none;
    }
    [data-type='prices'] {
      ${ArtworkSubText} {
        display: flex;
      }
      a {
        display: none;
      }
      p {
        margin: 2px;
      }
    }
    p,
    a {
      color: ${(props) => props.theme.colors.lightGray};
      font-size: ${(props) => props.theme.fontSizes[2]}px;
    }
    ${Row} {
      margin: 0 0 5px;
    }
    ${Row} + ${Row} {
      align-items: center;
      flex-direction: column;
      ${Column}, ${Column} + ${Column} {
        flex-direction: row;
        width: 100%;
        justify-content: space-between;
        &[data-type='prices'] {
          flex-direction: column;
          align-items: flex-start;
        }
      }
    }
  }
`
export const Layout = styled(Column)`
  max-width: 1280px;
  padding: 16px;
  margin: 0 auto;
  ${Header} {
    justify-content: center;
    align-items: center;
    border-bottom: none;
    h1,
    p {
      width: 100%;
    }
    @media (max-width: ${(props) => props.theme.breakpoints[0]}) {
      h1 {
        font-size: 26px;
        border-bottom: none;
      }
    }
    ${Row} {
      align-items: center;
      justify-content: space-betweeen;
      @media (max-width: ${(props) => props.theme.breakpoints[0]}) {
        flex-direction: column;
        ${ActionsLinks} {
          border-top: 1px solid ${(props) => props.theme.colors.borderLight};
          padding: 10px;
        }
        ${Button} {
          margin: 10px 0;
        }
      }
    }
    ${Button},
    button[data-type="filter"] {
      @media (min-width: ${(props) => props.theme.breakpoints[1]}) {
        display: flex;
        max-width: 146px;
      }
    }
  }
`
export const ArtworkItem = styled.div`
  &:focus,
  > :focus {
    outline: none;
  }
  ${Row} {
    align-items: flex-start;
    ${Column} {
      flex: 1;
    }
    ${Column} + ${Column} {
      align-items: flex-end;
      ${ArtworkSubText} {
        font-size: ${(props) => props.theme.fontSizes[1]}px;
      }
    }
  }
  @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
    ${Row}[data-type='actions'] {
      align-items: center;
    }
  }
`
export const ArtworksList = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  grid-template-rows: 1fr;
  grid-column-gap: 40px;
  grid-row-gap: 50px;
  @media (max-width: 720px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-column-gap: 15px;
    grid-row-gap: 24px;
  }
  @media (max-width: 480px) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
    grid-column-gap: 15px;
    grid-row-gap: 50px;
  }
  ${ArtworkItem} {
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 100px;
  }
`
export const CollectionImage = styled.div`
  position: relative;
  @media (min-width: 1440px) {
    max-height: 290px;
  }
  [data-type='mainImage'] {
    width: 100%;
    display: block;
    pointer-events: none;
    object-fit: cover;
    object-position: center center;
    max-height: inherit;
    @media (min-width: 500px) {
      min-height: 206px;
      min-width: 210px;
    }
    @media (min-width: 1200px) {
      min-height: 290px;
      min-width: 260px;
    }
    img {
      width: inherit;
      height: auto;
      max-height: inherit;
    }
  }
`
export const UploadPanel = styled.div`
  width: 100%;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  background-color: #f5f5f5;
  padding: 10px;
  border: 2px dashed #333;
  @media (min-width: 1200px) {
    padding: 20px;
  }
`
export const UploadImage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background-color: #fff;
  min-height: 206px;
  min-width: 98%;
  @media (min-width: ${(props) => props.theme.breakpoints[1]}) {
    height: 260px;
    width: 260px;
    border: 20px solid #f5f5f5;
  }
`
export { Column, Row }
